import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import { useApiClient } from "../../../apiClient";
import { CourtRecordingDto } from "../../../models/court-recording/dto/court-recording.dto";
import { GET_COURT_RECORDINGS_QUERY_KEY } from "./useListCourtRecordings";
import { translate } from "../../../i18n";

export const useRetryCourtRecording = (organizationId: string) => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const toast = useToast();

    return useMutation({
        mutationKey: ['retryCourtRecording'],
        mutationFn: (id: string) =>
            client.fetchApi<CourtRecordingDto, {}>({
                endpoint: `court-recordings/${id}/retry`,
                method: 'POST',
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_COURT_RECORDINGS_QUERY_KEY(organizationId) });
            toast({ title: translate('court_recording.retry_queued'), status: 'success', duration: 2000 });
        },
        onError: (err) => {
            toast({
                title: translate('court_recording.retry_failed'),
                description: err instanceof Error ? err.message : undefined,
                status: 'error',
            });
        },
    });
};
